import type { ReactElement, ReactNode } from 'react';
import { Error } from '@/components/Error';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { PageLayout } from './PageLayout';

export function DefaultPageLayout({
  children,
  hideGnbInSSR,
}: {
  children: ReactNode;
  hideGnbInSSR?: boolean;
}): ReactElement {
  return (
    <PageLayout hideGnbInSSR={hideGnbInSSR}>
      <ErrorBoundary fallback={<Error />}>{children}</ErrorBoundary>
    </PageLayout>
  );
}
